module.exports = "<div style=\"position:absolute;top:2650px;left:0px;width:100%;\">\n    <app-graph [id]=\"d.props.div_id\" *ngFor=\"let d of graphDataPerDimos;\" [data]=\"d\" [graphOptions]=\"graphOptions\" [graphType]=\"graphType\"></app-graph>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/sofos/projects/anadigit/kounoupia-frontend/src/app/components/graph-manager/graph-manager.component.html
// module id = ../../../../../src/app/components/graph-manager/graph-manager.component.html
// module chunks = main